module.exports = __webpack_public_path__ + "img/dot_ring.a6cd2fcd.png";